import {
  CollaborationV1ExternalDocumentInput,
  CreateExternalDocumentMutation,
  CreateExternalDocumentMutationVariables,
  ExternalDocumentRefFragment,
  useCreateExternalDocumentMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useCreateExternalDocument = withStandardMutationHook<
  CreateExternalDocumentMutation,
  ExternalDocumentRefFragment,
  CreateExternalDocumentMutationVariables,
  'createExternalDocument',
  [CollaborationV1ExternalDocumentInput, string?]
>(
  useCreateExternalDocumentMutation,
  'createExternalDocument',
  (externalDocument, externalDocumentId) => ({
    externalDocument,
    externalDocumentId,
  }),
);
